<template>
  <Head>
    <title>{{ entry.seo.title }}</title>
    <meta property="description" :content="entry.seo.description" />
  </Head>

  <Layout :alerts="entry.alerts">
    <PageIntro :data="entry.pageMasthead"></PageIntro>

    <Calculator />

    <Hr />

    <SectionTextWithImg :data="entry.pageComponents.sectionText[0]" />

    <Hr />

    <CardGrid :data="entry.pageComponents.ctaCardGroup[0]"></CardGrid>

    <Subscribe />
  </Layout>
</template>

<script>
import Calculator from "../../Components/Page-Components/Calculator.vue";
import Hr from "../../Components/Atoms/Hr.vue";
import SectionTextWithImg from "../../Components/Page-Components/SectionTextWithImg.vue";
import Subscribe from "../../Components/Page-Components/Subscribe.vue";
import CardGrid from "../../Components/Page-Components/CardGrid.vue";

export default {
  components: {
    Calculator,
    Hr,
    SectionTextWithImg,
    Subscribe,
    CardGrid,
  },

  props: {
    siteUrl: String,
    entry: Object,
  },

  setup(props) {
    return {};
  },
};
</script>
